import React, { useEffect, useState } from 'react';
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://orsycscsxedyalbtvvlc.supabase.co'
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY;
console.log(supabaseKey);
const supabase = createClient(supabaseUrl, supabaseKey);

function AdminOverview() {
  const [reservations, setReservations] = useState([]);

  useEffect(() => {
    // Fetch reservations data from Supabase
    const fetchReservations = async () => {
      try {
        const { data, error } = await supabase.from('reservations').select('*');
        if (error) {
          throw error;
        }
        setReservations(data);
      } catch (error) {
        console.error('Error fetching reservations:', error.message);
      }
    };

    fetchReservations();
  }, []);

  return (
    <div>
      <h2>Admin Overview - Reservations</h2>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Date</th>
            <th>Time</th>
            {/* Add more columns as needed */}
          </tr>
        </thead>
        <tbody>
          {reservations.map((reservation) => (
            <tr key={reservation.id}>
              <td>{reservation.name}</td>
              <td>{reservation.email}</td>
              <td>{reservation.date}</td>
              <td>{reservation.time}</td>
              {/* Add more columns as needed */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AdminOverview;
